import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';

const LogoWithRedirectLink = ({
  image,
  isLogged,
  loggedInDefaultRedirect,
  loggedOutRedirectUrl,
}) => {
  const history = useHistory();
  const redirectUrl = isLogged ? loggedInDefaultRedirect : loggedOutRedirectUrl;
  const isClickEnabled = loggedOutRedirectUrl || isLogged;
  const handleClick = () => {
    if (isLogged) {
      history.push(redirectUrl);
    } else if (!loggedOutRedirectUrl) {
      return;
    }
    else {
      window.location.href = redirectUrl;
    }
  };

  return (
    <Box onClick={handleClick} style={{ cursor: isClickEnabled ? 'pointer' : 'default' }}>
      {image}
    </Box>
  );
};

LogoWithRedirectLink.propTypes = {
  image: PropTypes.node.isRequired,
  isLogged: PropTypes.bool.isRequired,
  loggedInDefaultRedirect: PropTypes.string,
  loggedOutRedirectUrl: PropTypes.string,
};
LogoWithRedirectLink.defaultProps = {
  loggedInDefaultRedirect: '/app/home',
  loggedOutRedirectUrl: '',
};

export default LogoWithRedirectLink;
